// A thin red-pen line along the top that fills as the reader scrolls through the article.
import { type RefObject, useEffect, useState } from "react";

export function ReadingProgress({ target }: { target: RefObject<HTMLElement | null> }) {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const el = target.current;
      if (!el) return;
      const { top, height } = el.getBoundingClientRect();
      const read = Math.min(1, Math.max(0, -top / Math.max(1, height - window.innerHeight)));
      setProgress(read);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [target]);
  return <div className="fixed inset-x-0 top-0 z-50 h-[3px] origin-left bg-signal" style={{ transform: `scaleX(${progress})` }} aria-hidden />;
}
